import { Skeleton } from 'primereact/skeleton';
import classes from './marketStrategySkeleton.module.scss';

const DrugMarketStrategySkeleton = () => {
  return (
    <div className={classes.marketSkeletonTable}>
      <Skeleton height="12rem"></Skeleton>
      <Skeleton height="12rem"></Skeleton>
    </div>
  );
};

export default DrugMarketStrategySkeleton;
